import {atom} from "recoil";
import {persistAtomEffect} from "../effects/persistAtom";
export const unidadeGetResponseState = atom({
  key: 'unidadeGetResponseState',
  default: null,
  effects: [
    persistAtomEffect
  ]
});
